import { defineMessages, FormattedMessage } from "react-intl";

const checkStatusMessages = defineMessages({
  issued: {
    id: "finance.checks.status.issued",
    defaultMessage: "Issued",
  },
  voided: {
    id: "finance.checks.status.voided",
    defaultMessage: "Voided",
  },
});

export function checkStatusMessage(status: string) {
  switch (status) {
    case "issued":
      return checkStatusMessages.issued;
    case "voided":
      return checkStatusMessages.voided;
    default:
      return status;
  }
}

export function formatCheckStatusMessage(status: string) {
  switch (status) {
    case "issued":
      return <FormattedMessage {...checkStatusMessages.issued} />;
    case "voided":
      return <FormattedMessage {...checkStatusMessages.voided} />;
    default:
      return status;
  }
}
